import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import storageApi from 'src/api/storage'

export const getOrFilterInventoryRecord = createAsyncThunk(
     'storage/fetchProductStorage ',
    async (query) => {
      const response = await storageApi.getOrFilterInventoryRecord(query)
      return response
    }
)

const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  detail: null,
  reload: false,

  status:'',
  inventoryRecord:[],
  productStorageNum:0,
  loading: true,
  error:'',
}

const slice = createSlice({
  name: 'storage',
  initialState,
  reducers: {
    addInventoryRecord(oldState, action) {
        let newProduct = action.payload;
        oldState.inventoryRecord = [...oldState.inventoryRecord, ...newProduct]
    },

    updateInventoryRecord(oldState,action) {
       let updatedProduct =action.payload;
       let filteredStorage =[...oldState.inventoryRecord].filter((each)=>each.id!==updatedProduct.id)
       oldState.inventoryRecord =[ updatedProduct,...filteredStorage]
    },

    deleteInventoryRecord(oldState, action) {
        let deleteId=action.payload;

        let storage= [...oldState.inventoryRecord].filter((each)=>each.id!==deleteId)

        oldState.inventoryRecord=storage
    },
    openModal(oldState) {
        oldState.isModalOpen = true
      },
  
      closeModal(oldState) {
        oldState.isModalOpen = false
        oldState.modalViewName = null
        oldState.modalViewParams = null
      },
  
      setModalViewName(oldState, action) {
        oldState.modalViewName = action.payload
      },
  
      setModalViewParams(oldState, action) {
        oldState.modalViewParams = action.payload
      },
      setReload(oldState, action) {
        oldState.reload = action.payload
      },
    
    
  },
  extraReducers: {
    [getOrFilterInventoryRecord.pending]: (state, action) => {
        state.status = 'loading'
        state.loading = true
    },
    [getOrFilterInventoryRecord.fulfilled]: (state, action) => {
        state.status = 'succeeded'
        state.inventoryRecord = action.payload.content
        state.loading = false;
    },
    [getOrFilterInventoryRecord.rejected]: (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
    }
}

})

export const reducer = slice.reducer

/* Modal */
export const setModalViewName = (viewName) => (dispatch) => {
    dispatch(slice.actions.setModalViewName(viewName))
  }
  
  export const setModalViewParams = (params) => (dispatch) => {
    dispatch(slice.actions.setModalViewParams(params))
  }
  
  export const openModal = () => (dispatch) => {
    dispatch(slice.actions.openModal())
  }
  
  export const closeModal = () => (dispatch) => {
    dispatch(slice.actions.closeModal())
  }
  
  export const setReload = (reload) => (dispatch) => {
    dispatch(slice.actions.setReload(reload))
  }


// Product Storage dispatch
export const addInventoryRecord = (requestBody) => async (dispatch) =>{
  const result = await storageApi.addInventoryRecord(requestBody)
  dispatch(slice.actions.addInventoryRecord(result))
}

export const updateInventoryRecord = (requestBody) => async (dispatch) =>{
  const result =await storageApi.updateInventoryRecord (requestBody)
  dispatch(slice.actions.updateInventoryRecord(result))
}

export const deleteInventoryRecord= (productStorageId) => async (dispatch) =>{
  const result =await storageApi.deleteInventoryRecord(productStorageId)
  dispatch(slice.actions.deleteInventoryRecord(productStorageId))
}

export default slice
